import { SupTabContext, SupTabPanel, SupTabs } from "@repo/core-ui";
import React, { useState } from "react";
import dynamic from "next/dynamic";
import CredSection from "../../UI/CredSection";
import CredSectionHeadings from "../../UI/CredSectionHeadings";
import { SupTab } from "./SupTab";
import useHomeTVL from "@/hooks/api/cred/useHomeTVL";
import useHomeCred from "@/hooks/api/cred/useHomeCred";

const TVL = dynamic(() => import("./TVL"), { ssr: false });
const Cred = dynamic(() => import("./Cred"), { ssr: false });

export default function CredHomeBoards() {
  const [activeTab, setActiveTab] = useState("tvl");
  const { isLoading: isTVLLoading, data: tvlData } = useHomeTVL();
  const { isLoading: isCredLoading, data: credData } = useHomeCred();

  return (
    <CredSection>
      <SupTabContext value={activeTab}>
        <React.Fragment>
          <div className="grid grid-cols-1 md:grid-cols-2">
            <CredSectionHeadings heading={activeTab === "tvl" ? `TVL LEADERBOARD` : `CRED LEADERBOARD`} subheading="THE MORE YOU DEPOSIT, THE MORE YOU BOOST." />
            <div>
              <SupTabs onChange={(newValue: string | number) => setActiveTab(newValue as string)} className="bg-neutral-75 px-1 py-2">
                <SupTab label="TVL" value="tvl" />
                <SupTab label="CRED" value="cred" />
              </SupTabs>
            </div>
          </div>

          {activeTab === "tvl" ? (
            <SupTabPanel className="py-4" value="tvl">
              <TVL data={tvlData} isLoading={isTVLLoading} />
            </SupTabPanel>
          ) : (
            <SupTabPanel className="py-4" value="cred">
              <Cred data={credData} isLoading={isCredLoading} />
            </SupTabPanel>
          )}
        </React.Fragment>
      </SupTabContext>
    </CredSection>
  );
}
